// extracted by mini-css-extract-plugin
module.exports = {"portfolio__markdown":"Portfolio_portfolio__markdown__PqA2o","portfolio__arrow":"Portfolio_portfolio__arrow__3ZdBU"};